// @ts-check
import TransitionBlocker from "Components/Common/TransitionBlocker";
import LoadView from "Components/Common/loadView";
import DocUsersServerSettings from "Components/UsersServerSettings/DocUsersServerSettings";
import MeetUsersServerSettings from "Components/UsersServerSettings/MeetUsersServerSettings";
import AppStore from "Stores/AppStore";
import migrationStore from "Stores/migrationStore";
import usersServerSettingsStore from "Stores/usersServerSettingsStore";
import 'Styles/otherSettings/otherSettings.scss';
import { observer } from "mobx-react";
import React, { Component } from "react";
import { Navigate } from "react-router-dom";

class UsersServerSettings extends Component {
    componentDidMount() {
        AppStore.OnMainComponentMount('Пользовательские настройки', 'users');
    }

    render() {
        if (migrationStore.migration.migrationNeeded) {
            return (
                <Navigate to={`${window.SmrLocation}/migration`} />
            )
        }

        let element = AppStore.isMeeting
            ? <MeetUsersServerSettings />
            : <DocUsersServerSettings />;

        return (
            <div className='other-settings'>
                <TransitionBlocker
                    blocked={usersServerSettingsStore.settings.settingsChanged}
                    title='У вас есть несохраненные изменения. Если вы покинете страницу, все изменения будут утеряны.' />

                <div className='other-settings-settings-container overflowing-element'>
                    {element}
                </div>

                <div className='settings-buttons-container'>
                    <button
                        className="blue-button"
                        onClick={() => usersServerSettingsStore.SaveSettings()}>
                        Сохранить
                    </button>
                </div>

                {usersServerSettingsStore.settingsLoading ? <LoadView modal={true} /> : ''}
            </div>
        );
    }
}

export default observer(UsersServerSettings);